<template>
	<div class="editor">
		<editor-menu-bar
			:editor="editor"
			v-slot="{ commands, isActive }"
			@keydown="$emit('keydown', $event)"
		>
			<div class="menubar">
				<button
					class="menubar__button"
					:class="{ 'is-active': isActive.bold() }"
					@click="commands.bold"
					title="Bold"
				>
					<i class="fas fa-bold"></i>
				</button>

				<button
					class="menubar__button"
					:class="{ 'is-active': isActive.italic() }"
					@click="commands.italic"
					title="Italic"
				>
					<i class="fas fa-italic"></i>
				</button>

				<button
					class="menubar__button"
					:class="{ 'is-active': isActive.strike() }"
					@click="commands.strike"
					title="Strikethrough"
				>
					<i class="fas fa-strikethrough"></i>
				</button>

				<button
					class="menubar__button"
					:class="{ 'is-active': isActive.underline() }"
					@click="commands.underline"
					title="Underline"
				>
					<i class="fas fa-underline"></i>
				</button>

				<button
					class="menubar__button"
					:class="{ 'is-active': isActive.heading({ level: 1 }) }"
					@click="commands.heading({ level: 1 })"
					title="Heading 1"
				>H1</button>

				<button
					class="menubar__button"
					:class="{ 'is-active': isActive.heading({ level: 2 }) }"
					@click="commands.heading({ level: 2 })"
					title="Heading 2"
				>H2</button>

				<button
					class="menubar__button"
					:class="{ 'is-active': isActive.heading({ level: 3 }) }"
					@click="commands.heading({ level: 3 })"
					title="Heading 3"
				>H3</button>

				<button
					class="menubar__button"
					:class="{ 'is-active': isActive.bullet_list() }"
					@click="commands.bullet_list"
					title="Bullet list"
				>
					<i class="fas fa-list"></i>
				</button>

				<button
					class="menubar__button"
					:class="{ 'is-active': isActive.ordered_list() }"
					@click="commands.ordered_list"
					title="Numbered list"
				>
					<i class="fas fa-list-ol"></i>
				</button>

				<button
					class="menubar__button"
					:class="{ 'is-active': isActive.blockquote() }"
					@click="cmd(commands.blockquote)"
					title="Quote"
				>"</button>

				<button class="menubar__button" @click="commands.horizontal_rule" title="Horizontal Line">
					<i class="fas fa-ruler-horizontal"></i>
				</button>

				<button class="menubar__button" @click="commands.undo" title="Undo">
					<i class="fas fa-undo"></i>
				</button>

				<button class="menubar__button" @click="commands.redo" title="Redo">
					<i class="fas fa-redo"></i>
				</button>

				<button class="menubar__button" @click="showsearch = !showsearch" title="Search &amp; replace">
					<i class="fas fa-search"></i>
				</button>
				<!--
				<button
					class="menubar__button"
					title="Table"
					@click="commands.createTable({rowsCount: 3, colsCount: 3, withHeaderRow: false })"
				>
					<i class="fas fa-table"></i>
				</button>

				<div v-if="isActive.table()">
					<button class="menubar__button" @click="commands.deleteTable">
						<icon name="delete_table"/>
					</button>
					<button class="menubar__button" @click="commands.addColumnBefore">
						<icon name="add_col_before"/>
					</button>
					<button class="menubar__button" @click="commands.addColumnAfter">
						<icon name="add_col_after"/>
					</button>
					<button class="menubar__button" @click="commands.deleteColumn">
						<icon name="delete_col"/>
					</button>
					<button class="menubar__button" @click="commands.addRowBefore">
						<icon name="add_row_before"/>
					</button>
					<button class="menubar__button" @click="commands.addRowAfter">
						<icon name="add_row_after"/>
					</button>
					<button class="menubar__button" @click="commands.deleteRow">
						<icon name="delete_row"/>
					</button>
					<button class="menubar__button" @click="commands.toggleCellMerge">
						<icon name="combine_cells"/>
					</button>
				</div>-->
				<div class="search" v-if="showsearch">
					<input
						ref="search"
						@keydown.enter.prevent="editor.commands.find(searchTerm)"
						placeholder="Search …"
						type="text"
						v-model="searchTerm"
					/>
					<input
						@keydown.enter.prevent="editor.commands.replace(replaceWith)"
						placeholder="Replace …"
						type="text"
						v-model="replaceWith"
					/>
					<button class="buttonsearch" @click="editor.commands.find(searchTerm)">Find</button>
					<button class="buttonsearch" @click="editor.commands.clearSearch()">Clear</button>
					<button class="buttonsearch" @click="editor.commands.replace(replaceWith)">Replace</button>
					<button class="buttonsearch" @click="editor.commands.replaceAll(replaceWith)">Replace All</button>
				</div>
			</div>
		</editor-menu-bar>
		<br />
		<editor-content class="editor__content" :editor="editor" />
	</div>
</template>

<script>
	import { Editor, EditorContent, EditorMenuBar } from "tiptap";
	import { insertText } from "tiptap-commands";
	import {
		Blockquote,
		CodeBlock,
		HardBreak,
		Heading,
		HorizontalRule,
		OrderedList,
		BulletList,
		ListItem,
		TodoItem,
		TodoList,
		Bold,
		Code,
		Italic,
		Link,
		Strike,
		Underline,
		History,
		Image,
		Search,
		Table,
		TableHeader,
		TableCell,
		TableRow
	} from "tiptap-extensions";
	import { eParticaAction } from "../../../Models/ParticaEvent";
	export default {
		name: "ArticleBody",
		props: {
			value: {}
		},
		components: {
			EditorContent,
			EditorMenuBar
		},
		data() {
			return {
				searchTerm: null,
				replaceWith: null,
				showsearch: false,
				editor: new Editor({
					extensions: [
						new Blockquote(),
						new BulletList(),
						new CodeBlock(),
						new HardBreak(),
						new Heading({ levels: [1, 2, 3] }),
						new HorizontalRule(),
						new ListItem(),
						new OrderedList(),
						new TodoItem(),
						new TodoList(),
						new Link(),
						new Bold(),
						new Code(),
						new Italic(),
						new Strike(),
						new Underline(),
						new History(),
						new Image(),
						new Search({
							disableRegex: false
						}),
						new Table({
							resizable: true
						}),
						new TableHeader(),
						new TableCell(),
						new TableRow()
					],
					content: this.value.text
				})
			};
		},
		watch: {
			value: function() {
				this.editor.setContent(this.value.text);
			}
		},
		beforeDestroy() {
			this.editor.destroy();
		},
		mounted() {
			this.editor.on("update", ({ getHTML }) => {
				this.value.text = getHTML();
				this.$emit("partica-event", {
					action: eParticaAction.PROPERTY_CHANGED
				});
			});
			this.editor.setContent(this.value.text);
		},
		methods: {
			cmd(command) {
				command();
			},
			doInsertImage(command) {
				// inserts image programmatically
				command({
					src:
						"https://www.google.com.au/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png"
				});
				// give focus back to editor
				this.editor.focus();
			},
			doInsertText() {
				const { view } = this.editor;
				// inserts char programmatically
				insertText("some text from somwhere.")(
					view.state,
					view.dispatch,
					view
				);
				// give focus back to editor
				this.editor.focus();
			}
		}
	};
</script>
<style scoped>
.menubar__button {
	border: 1px solid grey;
	background-color: white;
	color: black;
	font-size: 16px;
	cursor: pointer;
	width: 38px;
	height: 30px;
}

.editor__content {
	border-top-width: 1px solid grey;
	overflow: auto;
	min-height: 50px;
	border: 1px solid grey;
}

img {
	max-width: 600px;
	max-height: 400px;
	width: 600px;
	height: 400px;
	object-fit: contain;
}
table {
	border-collapse: collapse;
}
th,
td {
	border: 1px solid grey;
}
</style>
<style>
blockquote {
	background: #f9f9f9;
	border-left: 10px solid #ccc;
	margin: 1.5em 10px;
	padding: 0.5em 10px;
	quotes: "\201C""\201D""\2018""\2019";
}
blockquote:before {
	color: #ccc;
	content: open-quote;
	font-size: 4em;
	line-height: 0.1em;
	margin-right: 0.25em;
	vertical-align: -0.4em;
}
blockquote p {
	display: inline;
}

.search {
	display: flex;
	flex-wrap: wrap;
	background-color: #cccccc;
	padding: 0.5rem;
	border-radius: 5px;
	margin-top: 1rem;
}
.buttonsearch {
	padding: 0.25rem;
	border: 1px solid grey;
	border-radius: 3px;
	margin-right: 0.2rem;
	font: inherit;
	font-size: 0.8rem;
	width: 20%;
	flex: 1;
	color: black;
}

.find {
	background: rgba(255, 213, 0, 0.5);
}
</style>
